import _ from 'lodash';

export const isVideoOverlayOpened = state =>
  _.get(state, 'fullScreenModal.lightbox');
